export const DISCOUNT_METHODS = {
  FLAT: '-',
  FLAT_PER_ITEM: 'flat_per_item',
  PERCENTAGE: '*',
  FREE_USB: 'free_usb',
  FREE_SHIPPING: 'free_book_shipping',
}
